import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import host from "../../global.jsx";

import { getWhiteLabelFromJobLink } from "../../utils/whitelabel";
import { AlertCircle, CircleCheckBig } from "lucide-react";
import 'react-quill/dist/quill.snow.css';
const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL;

export const Header = ({ jobDetails, organizationName, branding, isWhiteLabelingEnable }) => {
    return (
      <div className={`${isWhiteLabelingEnable ? 'bg-[#FAFAFA]' : 'glass-effect'} px-4 sm:px-8 py-4 sm:py-6 shadow-sm`}>
        <div className="w-full text-left">
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0">
              {/* Logo */}
                <div className="w-[70px] h-[55px] sm:w-[120px] sm:[80px] flex items-center justify-center overflow-hidden rounded-xl">
                  <img
                    src={isWhiteLabelingEnable ? branding?.logoDemo || '/Homepagelogo.png' : '/Homepagelogo.png'}
                    alt={branding?.companyName || "GenieHire"}
                    className="max-w-full max-h-full object-contain rounded-sm"
                  />
                </div>
            </div>

            <div>
              {/* Job Title */}
              <div className="flex items-center mb-1">
                <h1 className={`text-3xl font-bold ${isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
                  {jobDetails.job_role}
                </h1>
              </div>

              {/* Company name + website */}
              <div className="flex items-center gap-2 mb-1">
                <span className={`text-sm ${isWhiteLabelingEnable ? 'text-gray-500' : 'text-gray-300'}`}>
                  {organizationName}
                  </span>
                {/* <span className="text-gray-300">·</span>
                <a href="https://nsquarexyz.com" className="text-purple-500 text-sm hover:underline">
                  nsquarexyz.com ↗
                </a> */}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  };

  const AboutCompany = ({ organizationName, branding, isWhiteLabelingEnable, aboutOrg, orgWebsite }) => {
    return (
      <>
      <style>{`
        .about-company-content .ql-size-small { font-size: 0.75em; }
        .about-company-content .ql-size-large { font-size: 1.5em; }
        .about-company-content .ql-size-huge { font-size: 2em; }
        .about-company-content p { margin: 0 0 8px; }
        .about-company-content ul { padding-left: 20px; margin: 0 0 8px; list-style: disc; }
        .about-company-content ol { padding-left: 20px; margin: 0 0 8px; list-style: decimal; }
        .about-company-content li { margin-bottom: 4px; }
        .about-company-content strong { font-weight: 600; }
        .about-company-content em { font-style: italic; }
        .about-company-content u { text-decoration: underline; }
        .about-company-content a { color: #a855f7; text-decoration: underline; }
      `}</style>
      <div>
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
          About The Company
        </p>
      </div>
      <div className="flex flex-row gap-3">
        {/* <div className="w-[100px] h-[55px] flex items-center justify-center overflow-hidden rounded-xl">
          <img
            src={isWhiteLabelingEnable ? branding?.logoDemo || '/Homepagelogo.png' : '/Homepagelogo.png'}
            alt={branding?.companyName || "GenieHire"}
            className="max-w-full max-h-full object-contain rounded-sm"
          />
        </div>     */}

        <div className="flex flex-col gap-0">
          <p className={`font-semibold leading-tight mb-0 ${isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
            {organizationName}
            </p>
            <a 
              href={orgWebsite?.startsWith('http') ? orgWebsite : `https://${orgWebsite}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-purple-500 text-xs hover:underline"
            >
              {orgWebsite} 
            </a>
        </div>
      </div>

      <div className="border-t border-2px border-gray-500 mt-4 mb-5" />
             
      <div
        className={`text-sm leading-relaxed ${isWhiteLabelingEnable ? 'text-gray-700' : 'text-gray-300'} about-company-content`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(aboutOrg?.startsWith('<') ? aboutOrg : aboutOrg?.replace(/\n/g, '<br/>') || '')
        }}
      />

<style>{`
  .about-company-content p { margin: 0 0 8px; }
  .about-company-content ul { padding-left: 20px; margin: 0 0 8px; list-style: disc; }
  .about-company-content ol { padding-left: 20px; margin: 0 0 8px; list-style: decimal; }
  .about-company-content li { margin-bottom: 4px; }
  .about-company-content strong { font-weight: 600; }
  .about-company-content em { font-style: italic; }
  .about-company-content u { text-decoration: underline; }
  .about-company-content a { color: #a855f7; text-decoration: underline; }
`}</style>
      </>
    );
  };

  export const JobDetails = ({ jobDetails, isWhiteLabelingEnable }) => {
    return (
      <div>
        
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
          Job Details
        </p>

        <div className="space-y-4">
          <div className="flex items-center justify-between border-b border-2px border-gray-500 pb-4">
            <span className={`text-sm ${isWhiteLabelingEnable ? 'text-gray-700' : 'text-gray-300'}`}>Job Type</span>
            <span className={`font-semibold text-sm ${isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
              {jobDetails.job_type || "Full Time"}
            </span>
          </div>
          <div className="flex items-center justify-between border-b border-2px border-gray-500 pb-4">
            <span className={`text-sm ${isWhiteLabelingEnable ? 'text-gray-700' : 'text-gray-300'}`}>
              Experience
            </span>

            <span
              className={`text-gray-900 font-semibold text-sm ${
                isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'
              }`}
            >
              {jobDetails.description?.minExp === 0 &&
              jobDetails.description?.maxExp === 0
                ? "Fresher"
                : `${jobDetails.description?.minExp ?? "--"} – ${
                    jobDetails.description?.maxExp ?? "--"
                  } Years`}
            </span>
          </div>
          <div className="flex items-center justify-between border-b border-2px border-gray-500 pb-4">
            <span className={`text-sm ${isWhiteLabelingEnable ? 'text-gray-700' : 'text-gray-300'}`}>Location</span>
            <span className={`text-gray-900 font-semibold text-sm ${isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
              {jobDetails.location || "--"}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className={`text-sm ${isWhiteLabelingEnable ? 'text-gray-700' : 'text-gray-300'}`}>Posted</span>
            <span className={`text-gray-900 font-semibold text-sm ${isWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
              {new Date(jobDetails.created_at).toLocaleDateString("en-US", { 
                month: "short", 
                year: "numeric" 
              }) || "--"}
            </span>
          </div>
        </div>

      </div>
    );
  };

const JobDescriptionViewer = ({ 
  jobDetails: propJobDetails, 
  organizationName: propOrgName,
  branding: propBranding,
  isWhiteLabelingEnable: propWhiteLabelingEnable,
  isLoading: propIsLoading,
  onApply 
}) => {
  const { linkToken } = useParams();
  const [jobDetails, setJobDetails] = useState(null);
  const [organizationName, setOrganizationName] = useState("Loading...");
  const [isLoading, setIsLoading] = useState(true);
  const [branding, setBranding] = useState(null);
  const [questionType, setQuestionType] = useState("");

  // Candidate must accept the privacy policy before applying
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  // White labeling State
  const [isWhiteLabelingEnable, setisWhiteLabelingEnable] = useState(false);

  // Derived state to use props if available
  const displayJobDetails = propJobDetails || jobDetails;
  const displayOrgName = propOrgName || organizationName;
  const displayBranding = propBranding || branding;
  const displayIsWhiteLabelingEnable = propWhiteLabelingEnable !== undefined ? propWhiteLabelingEnable : isWhiteLabelingEnable;
  const displayIsLoading = propIsLoading !== undefined ? propIsLoading : isLoading;
  const displayQuestionType = propJobDetails?.questionType || questionType;

  useEffect(() => {
    if (!propJobDetails) {
      fetchJobDetails();
      fetchBranding();
    }
  }, [linkToken, propJobDetails]);

  const fetchBranding = async () => {
    try {
      const brandingConfig = await getWhiteLabelFromJobLink(linkToken);
      // Remove Console Log
      // console.log({brandingConfig})
      setBranding(brandingConfig);
      setisWhiteLabelingEnable(brandingConfig.whitelabelEnabled);
    } catch (error) {
      console.error("Failed to load white-label branding:", error);
      setBranding(null);
    }
  };

  const fetchOrganizationName = async (adminId) => {
    try {
      const response = await axios.get(
        `${host}/get-organization-by-admin/${adminId}`
      );
      setOrganizationName(response.data.OrganizationName || "Company");
    } catch (error) {
      setOrganizationName("Company");
    }
  };

  const fetchJobDetails = async () => {
    try {
      const response = await axios.get(
        `${host}/public/job-details/${linkToken}`
      );
      setJobDetails(response.data);
      setQuestionType(response.data.questionType || "");

      // Set organization name from response
      if (response.data.organization_name) {
        setOrganizationName(response.data.organization_name);
      } else {
        const adminId =
          response.data.admin_id ||
          response.data.created_by ||
          response.data.org_admin_id;
        if (adminId) {
          await fetchOrganizationName(adminId);
        } else {
          setOrganizationName("Company");
        }
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching job details:", error);
      setIsLoading(false);
    }
  };


  const formatJobDescription = (data) => {
    if (!data) return null;

    const renderTextWithBullets = (text) => {
      if (!text) return null;
      const lines = text.split('\n').filter(line => line.trim() !== '');

      return (
        <div className="space-y-3">
          {lines.map((line, index) => {
            const trimmedLine = line.trim();
            const isBullet = /^[-•*]\s*/.test(trimmedLine);
            
            if (isBullet) {
              const cleanLine = trimmedLine.replace(/^[-•*]\s*/, '');
              return (
                <div key={index} className="flex items-start gap-3">
                  <CircleCheckBig className={`w-[17px] h-[17px] flex-shrink-0 mt-[3px] ${
                    displayIsWhiteLabelingEnable ? 'text-[#C1A0D0]' : 'text-[#F2EDFB]'
                  }`} />
                  <span className={`${displayIsWhiteLabelingEnable ? 'text-[#6B6680]' : 'text-gray-300'} text-[14.5px] leading-[1.8]`}>
                    {cleanLine}
                  </span>
                </div>
              );
            }

            return (
              <p key={index} className={`${displayIsWhiteLabelingEnable ? 'text-gray-600' : 'text-gray-300'} text-[14.5px] leading-[1.8] whitespace-pre-wrap m-0`}>
                {trimmedLine}
              </p>
            );
          })}
        </div>
      );
    };

    // Split the raw job description into two parts: before and after "Key Responsibilities" --> For V1 Flow
    const rawText = data.Raw_Job_Description ?? "";
    const parts = rawText.split("Key Responsibilities:"); 
    const descriptionText = parts[0].trim();
    const responsibilitiesText = parts[1]?.trim() || "";
    const responsibilityItems = responsibilitiesText
    .split('\n')
    .filter(line => line.trim().startsWith('•'))
    .map(line => line.replace('•', '').trim());

    if (displayQuestionType === "Initial Screening" || displayQuestionType === "Core Knowledge Evaluation" || displayQuestionType === "Bring Your Own Questions") {
      return (
        <div className="space-y-5">
        {/* Description */}
        {descriptionText && renderTextWithBullets(descriptionText)}

        {/* Key Responsibilities */}
        {responsibilityItems.length > 0 && (
          <div>
            <div className="border-t border-2px border-gray-500 mb-5" />
            <h5 className={`text-[13.5px] font-semibold ${displayIsWhiteLabelingEnable ? 'text-[#1A1714]' : 'text-white'} mb-4`}>
              Key Responsibilities
            </h5>
            <div className="space-y-3">
              {responsibilityItems.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  {/* <div className={`w-[17px] h-[17px] rounded-full flex-shrink-0 mt-[3px] ${
                    displayIsWhiteLabelingEnable 
                      ? 'bg-[#F2EDFB] border-[1.5px] border-[#D4C5F5]' 
                      : 'bg-[#C1A0D0]/20 border-[1.5px] border-[#C1A0D0]'
                  }`} /> */}
                  <CircleCheckBig className={`w-[17px] h-[17px]  mt-[3px] ${
                    displayIsWhiteLabelingEnable 
                      ? 'text-[#C1A0D0] ' 
                      : 'text-[#F2EDFB]'
                  }`}/>
                  <p className={`${displayIsWhiteLabelingEnable ? 'text-[#6B6680]' : 'text-gray-300'} text-[14.5px] leading-[1.8]`}>
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Fallback - if no "Key Responsibilities:" found, show raw text */}
        {responsibilityItems.length === 0 && !descriptionText && rawText && renderTextWithBullets(rawText)}
          
        {data.Raw_Required_Skills && data.Raw_Required_Skills.length > 0 && (
          <div>
            <h5 className={`text-[13.5px] font-semibold ${displayIsWhiteLabelingEnable ? 'text-[#1A1714]' : 'text-white'} mb-4`}>
              Required Skills
            </h5>
            <div className="space-y-2">
              {data.Raw_Required_Skills.map((skills, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CircleCheckBig className={`w-[17px] h-[17px]  mt-[3px] ${
                    displayIsWhiteLabelingEnable 
                      ? 'text-[#C1A0D0] ' 
                      : 'text-[#F2EDFB]'
                  }`}/>
                  <span className={`${displayIsWhiteLabelingEnable ? 'text-[#6B6680]' : 'text-gray-300'} text-[14.5px] leading-[1.8]`}>
                    {skills}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
        </div>
      );
    }

    // const experience = ((data.minExp || 0) + (data.maxExp || 1)) / 2;
    const responsibilities = data.Roles_and_Responsibilities?.slice(0, 5) || [];
    const skillsRquired = data.Raw_Required_Skills || [];
    


    return (
      <div className="space-y-5">
        
        {displayJobDetails.jobDescription && renderTextWithBullets(displayJobDetails.jobDescription)}

        {data.Raw_Required_Skills && data.Raw_Required_Skills.length > 0 && (
          <div>
            <h5 className="text-md font-medium text-gray-700 mb-3 border-b border-gray-300 pb-2">
              Required Skills
            </h5>
            <div className="space-y-2">
              {data.Raw_Required_Skills.map((skills, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CircleCheckBig className={`w-[17px] h-[17px]  mt-[3px] ${
                    displayIsWhiteLabelingEnable 
                      ? 'text-[#C1A0D0] ' 
                      : 'text-[#F2EDFB]'
                  }`}/>
                  <span className={`${displayIsWhiteLabelingEnable ? 'text-[#6B6680]' : 'text-gray-300'} text-[14.5px] leading-[1.8]`}>
                    {skills}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
        
      </div>
    );
  };




  
  

  if (displayIsLoading) {
    return (
      <div className={`min-h-screen  flex items-center justify-center ${displayIsWhiteLabelingEnable ? 'bg-[#FAF9F6]' : 'app-background'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </div>
    );
  }

  if (!displayJobDetails) {
    return (
      <div className={`min-h-screen ${displayIsWhiteLabelingEnable ? 'bg-[#FAF9F6]' : 'app-background'} flex items-center justify-center`}>
        <div className="text-center">
          <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
          <h2 className={`text-2xl font-medium mb-2 ${displayIsWhiteLabelingEnable ? 'text-gray-700 ' : 'text-gray-300'}`}>Invalid Link</h2>
          <p className="text-gray-500">
            This job application link is invalid or has expired.
          </p>
        </div>
      </div>
    );
  }


return (
  <div className={`min-h-screen ${displayIsWhiteLabelingEnable ? 'bg-[#F1F4FB]' : 'app-background'}`}>
    <Header 
      jobDetails={displayJobDetails}
      organizationName={displayOrgName}
      branding={displayBranding}
      isWhiteLabelingEnable={displayIsWhiteLabelingEnable}
    />

    {/* Page Body */}
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
      <div className="flex flex-col lg:flex-row gap-8 items-start">

        {/* LEFT COLUMN */}
        <div className="flex-1 flex flex-col gap-6">
          
          {/* Card 1 - Role Overview */}
          <div className={`${displayIsWhiteLabelingEnable ? 'bg-[#FAFAFA]' : 'glass-effect'} rounded-2xl p-4 sm:p-8 shadow`}>

            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
              Role Overview
            </p>

            {/* Job Title */}
            <h2 className={`text-2xl font-bold mb-4 ${displayIsWhiteLabelingEnable ? 'text-gray-900' : 'text-white'}`}>
              {displayJobDetails.job_role}
            </h2>


            {/* Use existing formatJobDescription function */}
            {formatJobDescription(
              displayJobDetails.description
            )}

          </div>
          
          {/* Card 2 - About Company */}
          {displayJobDetails?.about_company && (
            <div className={`${displayIsWhiteLabelingEnable ? 'bg-[#FAFAFA]' : 'glass-effect'} rounded-2xl p-8 shadow`}>
              <AboutCompany 
                organizationName={displayOrgName}
                branding={displayBranding}
                isWhiteLabelingEnable={displayIsWhiteLabelingEnable}
                aboutOrg={displayJobDetails.about_company}
                orgWebsite={displayJobDetails.website_link}
              />
            </div>
          )}
        </div>

        {/* RIGHT COLUMN */}
        <div className="w-full lg:w-80 flex flex-col gap-6 lg:sticky lg:top-8">
          
          {/* Card 1 - Job Details */}
          <div className={`${displayIsWhiteLabelingEnable ? 'bg-[#FAFAFA]' : 'glass-effect'} rounded-2xl p-6 shadow`}>
            <JobDetails 
              jobDetails={displayJobDetails}
              isWhiteLabelingEnable={displayIsWhiteLabelingEnable}
            />
          </div>

          {onApply && (
            <div className={`${displayIsWhiteLabelingEnable ? 'bg-[#FAFAFA]' : 'glass-effect'} rounded-2xl p-6 shadow`}>
              <p className={`text-sm ${displayIsWhiteLabelingEnable ? 'text-gray-600' : 'text-gray-300'} mb-4 leading-relaxed`}>
                Interested in this role? Submit your application and our team will be in touch shortly.
              </p>

              <div className={`flex items-start gap-3 mb-4 text-xs leading-relaxed ${displayIsWhiteLabelingEnable ? 'text-gray-600' : 'text-gray-300'}`}>
                <input
                  id="privacy-consent"
                  type="checkbox"
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-gray-400 accent-[#1569c4] cursor-pointer"
                />
                <label htmlFor="privacy-consent" className="cursor-pointer">
                  By submitting my application, I consent to the collection and processing of my
                  personal data for recruitment purposes in accordance with the{' '}
                  <a
                    href={PRIVACY_POLICY_URL || "https://geniehire.ai/privacy-policy"}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className={`underline font-medium ${displayIsWhiteLabelingEnable ? 'text-[#1569c4]' : 'text-purple-400'}`}
                  >
                    Privacy Policy
                  </a>.
                </label>
              </div>

              <button
                onClick={onApply}
                disabled={!privacyAccepted}
                className={`w-full py-3 px-6 rounded-xl font-semibold text-sm tracking-wide transition-all duration-150 shadow-md active:scale-[0.98] ${
                  !privacyAccepted
                    ? 'bg-gray-400 text-white cursor-not-allowed opacity-60 active:scale-100'
                    : displayIsWhiteLabelingEnable
                    ? 'bg-[#1569c4] hover:bg-[#125eaf] text-white'
                    : 'bg-gradient-to-r from-purple-600 to-pink-500 text-white hover:opacity-90'
                }`}
              >
                Apply Now →
              </button>
            </div>
          )}

        </div>
      </div>
    </div>

  </div>
);
};

export default JobDescriptionViewer;
